import React from 'react';
import { Link } from 'react-router-dom';

export default function Button({ onClick, icon, label, style, to }) {
	return <Link to={to} style={style} className="btn" onClick={onClick || (() => {})}>
		{icon && <span className={'fa fa-' + icon} />}
		{label && <span>{label}</span>}
	</Link>;
}
